/**
 * Initializes Google Tag Manager with the provided GTM ID, unless:
 * 1. The current page is /process-zuora
 * 2. The environment variable REACT_APP_EXCLUDE_GTM is set to 'true'
 * 3. The gtmId is missing
 * @param {string} gtmId - Google Tag Manager ID (e.g., 'GTM-XXXXXXX')
 */
export const initializeGTM = (gtmId) => {
  if (window.location.pathname === '/process-zuora') {
    console.log('GTM not initialized: /process-zuora page');
    return;
  }

  if (process.env.REACT_APP_EXCLUDE_GTM === 'true') {
    console.log('GTM not initialized: REACT_APP_EXCLUDE_GTM is true');
    return;
  }

  if (!gtmId) {
    console.warn('GTM not initialized: missing gtmId');
    return;
  }

  // Initialize dataLayer if it doesn't exist
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

  // Load GTM script if not already present
  if (!document.querySelector(`script[src*="googletagmanager.com/gtm.js?id=${gtmId}"]`)) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    
    const firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(script, firstScript);
    
    console.log(`GTM initialized with ID: ${gtmId}`);
  }
};
